export default __webpack_public_path__ + "static/media/Magewalk Slippers.5dd7c667.jpg";